import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styleMap } from 'lit/directives/style-map.js';
import { styles } from './css';

export class Gerry extends Lit3formBlock {
  static get characterName() {
    return 'gerry';
  }

  static get characterProperties() {
    return {
      backgroundColorOverride: { type: String },
      textColorOverride: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  constructor() {
    super();
    this.backgroundColorOverride =
      this.content.background_color_override || undefined;
    this.textColorOverride = this.content.text_color_override || undefined;
  }

  render() {
    const styles = {
      backgroundColor: this.backgroundColorOverride,
      color: this.textColorOverride,
    };
    return html`
      <div class="block-wrapper">
        <div class="block-grid gerry-layout">
          <div class="${classMap(this.textClasses)}" style=${styleMap(styles)}>
            <h3 class="text">${unsafeHTML(this.textBody)}</h3>
          </div>
          <div class="${classMap(this.imageClasses)}">
            <img src="${this.imageUrl}" />
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  // big_panel = text, image
  // text_alignment = left, right
  get textClasses() {
    const textLeft = this.content.text_alignment === 'left';
    const textBigPanel = this.content.big_panel === 'text';
    const classes = {
      'text-wrapper': true,
      'text-left': textLeft,
      'text-right': !textLeft,
      'text-big-panel': textBigPanel,
      'text-small-panel': !textBigPanel,
    };
    return classes;
  }

  get imageClasses() {
    const imageLeft = this.content.text_alignment === 'right';
    const imageBigPanel = this.content.big_panel === 'image';
    const classes = {
      'image-wrapper': true,
      'image-left': imageLeft,
      'image-right': !imageLeft,
      'image-big-panel': imageBigPanel,
      'image-small-panel': !imageBigPanel,
    };
    return classes;
  }

  get textBody() {
    return this.withLineBreaks(this.content.text_body) || '';
  }

  get imageUrl() {
    return !!this.content.image
      ? this.imagebossUrl(this.content.image.src, 1000, null)
      : '';
  }
}
Gerry.defineElement();
